import UsersModal from './components';

export default UsersModal;



// WEBPACK FOOTER //
// ./src/components/UsersModal/index.js